import { useContext, useState, useEffect } from "react";
import MultiComparisonComponent from "../../Dashboard/Component/MultiComparisonComponent";
import { DiscoveryContext } from "../discovery-context";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import classes from "./PersonaSummary.module.css";
import { useIsSelectedSection } from "../discovery-context";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import { filterKey } from "../BrandAudit";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Modal from "../../../Component/Modal/Modal";
import Share from "../Share/Share";
import { toast } from "react-toastify";

export default function PersonaSummary() {

    const discoveryCtx = useContext(DiscoveryContext);
    const [showShareModal, setShowShareModal] = useState(false);
    let primary_llm = discoveryCtx.primary_llm;
    const selectedMarket = discoveryCtx.state.selectedMarket;
    let llms = discoveryCtx.llm;
    const selectedCategory = discoveryCtx.state.selectedCategory
    const selectedPersona = discoveryCtx.state.selectedPersona;
    const personas = discoveryCtx?.persona || [];
    const id = "Persona_Summary";
    /*we need to pass uniqueKey because it only selectedCategory*/
    let uniqueKey = `${tab.personaOverview}_${id}_${selectedCategory}_${selectedMarket}`;
    const { checked } = useIsSelectedSection({
        id,
        tab: tab.personaOverview,
        uniqueKey,
    });

   const extractPersonaTitles = (personas = []) =>
  personas.map(p => (typeof p === "string" ? p : p?.title)).filter(Boolean);

    const getBrandScores = (type) => {
        const brandScoresMap = {};
        let mainBrandProduct = null;

        if (!Array.isArray(llms) || llms.length === 0) {
            return { brandScoresMap, mainBrandProduct };
        }

        llms.forEach((llm) => {
            const llmScores = discoveryCtx?.brand_scores?.[llm] || {};
            const categories = Object.keys(llmScores || {});


            categories.forEach((category) => {
                const categoryScores = llmScores?.[category] || {};
                const marketScores = categoryScores?.[selectedMarket] || {};

                personas.forEach(({ title: persona }) => {
                    const personaData = marketScores?.[persona] || [];

                    // persona slice logic → keep first item + persona slice(1)
                    const mappedValues = [
                        personaData[0] || null,
                        ...personaData.slice(1),
                    ]
                        .map((item) =>
                            item && item[type] !== undefined ? item[type] : null
                        );

                    if (!brandScoresMap[llm]) brandScoresMap[llm] = {};
                    if (!brandScoresMap[llm][category]) brandScoresMap[llm][category] = {};
                    // if (!brandScoresMap[llm][category][selectedMarket])
                    //     brandScoresMap[llm][category][selectedMarket] = {};

                    brandScoresMap[llm][category][persona] = mappedValues;

                    // set mainBrandProduct only once
                    if (!mainBrandProduct && personaData[0]?.name) {
                        mainBrandProduct = personaData[0].name;
                    }
                });
            });
        });

        return { brandScoresMap, mainBrandProduct };
    };


    const getIndexScoreMetaData = () => {
        const personas = discoveryCtx.persona;
        let indexScoreMetaData = [];

        llms.forEach((llm) => {
            const llmScores = discoveryCtx?.brand_scores?.[llm] || {};
            const categories = Object.keys(llmScores || {});

            categories.forEach((category) => {
                const marketScores = llmScores?.[category]?.[selectedMarket] || {};

                personas.forEach(({ title: persona }) => {
                    const personaScores = marketScores?.[persona] || [];

                    const firstItem = personaScores[0]; // slice(0,1)

                    if (firstItem) {
                        indexScoreMetaData.push({
                            ...firstItem,
                            category,
                            market: selectedMarket,
                            llm,
                            persona,
                            geography: ""
                        });
                    }
                });
            });
        });

        return indexScoreMetaData;
    };

    return (
        <>
            <div className="Heading-checkbox">
                <div className={classes.dropdownWrapper}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h5>Persona Summary</h5>
                        {discoveryCtx.state.showReportCheckbox && (
                            <Checkbox
                                checked={checked}
                                onChange={() => {
                                    discoveryCtx?.clickComponentCheckbox({
                                        uniqueKey,
                                        filter: {
                                            id: id,
                                            title: "Persona Summary",
                                            tab: tab.personaOverview,
                                            uniqueKey,
                                            llm: null,
                                            persona: null
                                        },
                                        checked,
                                        id,
                                    });
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        )}
                    </div>
                    <div className={classes.marketWrapper}>
                        <MUISelect
                            fullWidth={false}
                            optionValue={discoveryCtx.state.selectedCategory}
                            label={"Category"}
                            id={filterKey.category}
                            options={(discoveryCtx.category || []).map((category) => {
                                return {
                                    name: category,
                                    value: category,
                                };
                            })}
                            onChange={(e) => {
                                discoveryCtx.updateSelectedCategory(e.target.value);
                            }}
                        />
                        <MUISelect
                            fullWidth={false}
                            optionValue={discoveryCtx.state.selectedMarket}
                            label={"Market"}
                            id={filterKey.market}
                            options={(discoveryCtx.markets || []).map((market) => {
                                return {
                                    name: market,
                                    value: market,
                                };
                            })}
                            onChange={(e) => {
                                discoveryCtx.updateSelectedMarket(e.target.value);
                            }}
                        />
                        <div className={classes.shareIcon}>
                            <MUIIconButton
                                title="Click to Share"
                                onClick={() => setShowShareModal(true)}
                            >
                                <ShareOutlinedIcon color="primary" />
                            </MUIIconButton>
                        </div>
                    </div>
                </div>


            </div>
            <hr />
            <MultiComparisonComponent
                fetchRealTimeActionsSources={() => { }}
                sourceURLIds={[]}
                reachSourceData={{}}
                sentimentSourceData={{}}
                categoryDimensionRatingSource={{}}
                secCategoryIndexScoreMetaData={{}}
                coreAttSourceData={{}}
                positiveAttSource={{}}
                negativeAttSource={{}}
                customerId={1}
                selectedInput={{
                    llm: primary_llm,
                    market: selectedMarket,
                    persona: selectedPersona,
                    brand: discoveryCtx.entity,
                    product: discoveryCtx.type == "product" ? true : false,
                    geography: "",
                    category: selectedCategory,
                }}
                productTaxonomyData={null}
                secCategoryBrandFav={{}}
                secCategoryReach={{}}
                secCategoryBrandIndex={{}}
                indexScoreMetaData={getIndexScoreMetaData()}
                compCoreAttributes={{}}
                compCategoryDimensions={{}}
                pastCompCategoryDimensions={{}}
                pastCompCoreAttributes={{}}
                pastsecCategoryBrandIndex={{}}
                pastIndexScoreObj={{}}
                brandIndex={getBrandScores("total").brandScoresMap}
                brandReach={getBrandScores("rank").brandScoresMap}
                brandFav={getBrandScores("favorability").brandScoresMap}
                positiveAttributes={{}}
                negativeAttributes={{}}
                llmDomains={{}}
                geoLogo={{}}
                activeTab={"category"}
                brandDomains={{}}
                brandProduct={getBrandScores("favorability").mainBrandProduct}
                type={discoveryCtx.type == "brand" ? "Brand" : "Product"}
                brandProductCategory={[]}
                isBrandAuditPage={true}
                isBrandAuditMarketPage={true}
                isOverview={true}
                personaOverview={extractPersonaTitles(discoveryCtx.persona)}
                id={id}
                contextData={discoveryCtx}
            />
            {showShareModal &&
                <Modal
                    height="60%"
                    title="Share Link"
                    open={showShareModal}
                    handleClose={() => setShowShareModal(false)}
                >
                    <Share setShowShareModal={setShowShareModal} />
                </Modal>
            }
        </>
    );
}
